import { createSelector } from 'reselect';
import getLangData from '../../utils/getLangData';
import langText from '../../utils/langText';

const artisanTagsStateSelector = state => state.artisanTags;
const selectById = (state, itemId) => itemId;

export const artisanTagsSelector = createSelector(
  [artisanTagsStateSelector],
  artisanTags => artisanTags.items
);

export const artisanTagsAsLabelAndValueSelector = createSelector(
  [artisanTagsSelector],
  tags =>
    tags.map(({ _id, name, namei18n }) => ({
      _id,
      name: langText(name, namei18n, getLangData().lang_code)
    }))
);

export const artisanTagByIdSelector = createSelector(
  [artisanTagsSelector, selectById],
  (artisanTags, _id) => {
    const tag = artisanTags.find(item => _id === item._id);
    if (!tag) return null;
    return tag;
  }
);

/**
 * Misc
 */

export const artisanTagsIsLoadingSelector = createSelector(
  [artisanTagsStateSelector],
  artisanTags => artisanTags.isLoading
);

export const artisanTagsCountSelector = createSelector(
  [artisanTagsStateSelector],
  artisanTags => artisanTags.count
);

export const searchValueSelector = createSelector(
  [artisanTagsStateSelector],
  artisanTags => artisanTags.searchValue
);
